(function (scope) {
  'use strict';
  function required(qty) { return Number(qty) === 1 ? [4, 6, 8] : [4, 8, 12]; }
  function allocation(pack, weeks) {
    var matches = pack.plans.filter(function (p) { return p.weeks === Number(weeks); });
    return matches.length === 1 ? matches[0] : null;
  }
  function evaluate(pack, weeks, subscribed) {
    if (!pack || !pack.available) return { error: 'This pack is unavailable.' };
    if (!subscribed) return { price: pack.price, formatted: pack.formatted, unit: pack.unit, plan: null };
    if (required(pack.qty).indexOf(Number(weeks)) < 0) return { error: 'Choose a delivery frequency for this pack.' };
    var plan = allocation(pack, weeks);
    if (!plan) return { error: 'This delivery frequency is unavailable. Please choose another frequency or one-time purchase.' };
    // Check the promised discount against actual allocation money, allowing currency rounding.
    if (Math.abs(plan.price - Math.round(pack.price * 0.85)) > 1) {
      return { error: 'This subscription price needs correction. Please choose another frequency or one-time purchase.' };
    }
    return { price: plan.price, formatted: plan.formatted, unit: plan.unit, plan: plan.id };
  }
  function payload(pack, weeks, subscribed) {
    var state = evaluate(pack, weeks, subscribed);
    if (state.error) throw new Error(state.error);
    var item = { id: pack.id, quantity: 1 };
    if (subscribed) item.selling_plan = state.plan;
    return { items: [item] };
  }
  var api = { required: required, allocation: allocation, evaluate: evaluate, payload: payload };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.HBSub02 = api;
}(typeof window !== 'undefined' ? window : this));
